import React, { Fragment } from 'react';
import $ from 'jquery';
import axios from 'axios';
import { EXPORT_METHODS } from '../Export/Export';
import { EXPORT_APIS } from '../../constants/endPointsURLs';
import { EXPORT_CREATION_SOURCE } from '../../constants/exportCreationSource';
import isEqual from 'lodash/isEqual';
import config from '../../dashboard_config.json';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  TelegramShareButton,
  EmailShareButton,
} from 'react-share';
import {
  FacebookIcon,
  FacebookMessengerIcon,
  TwitterIcon,
  TelegramIcon,
  WhatsappIcon,
  LinkedinIcon,
  EmailIcon,
} from 'react-share';
import './Modal.css';
import { isExistUser } from '../../utils/codecHandlers';

const copyIcon = './images/copy-icon-round.svg';
const facebookIcon = './images/facebook_icon.svg';
const youtubeIcon = './images/youtube_icon.svg';
const twitchIcon = './images/twitch_icon.svg';
const telegramIcon = './images/telegram_icon.svg';
const instagramIcon = './images/instagram_icon.svg';
const kickIcon = './images/kick_icon.svg';
const dacastIcon = './images/dacast_icon.svg';
const srtLogo = './images/srt_logo.svg';

const {
  showAmsExportsAndUseLogic,
  keepAmsExports,
  useAmsExportConvertAndLogic
} = config.dashboard.exports.amsExportsControl;

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.handleHideModalClose = this.handleHideModalClose.bind(this);
    this.handleDeleteModal = this.handleDeleteModal.bind(this);
    this.state = {
      currentOption: '',
      currentDisabled: false,
      formFields: {},
      exportName: '',
      focusedPrimaryId: '',
      disabled: false,
      localIp: '',
      showVmixIpInput: false,
      ipValidationError: '',
      modalError: '',
      fieldErrors: {},
      serverError: '',
      isConfirmDeleteGenerated: false,
      createdExportId: null,
      isRegenerated: false,
    };
  }

  handleConfirmDeleteGenerated = () => {
    const { createdExportId } = this.state;
    if (createdExportId) {
      if (this.props.handleDelete) {
        this.props.handleDelete(createdExportId);
      }
      if (this.props.deleteLabelItem) {
        this.props.deleteLabelItem(createdExportId);
      }
      if (this.props.fetchItems) {
        this.props.fetchItems(true, this.state.focusedPrimaryId);
      }
      if (this.props.showNotification) {
        this.props.showNotification(
          'export',
          `${this.state.exportName || 'Export'} deleted`
        );
      }
    }
    this.setState({ isConfirmDeleteGenerated: false, createdExportId: null, disabled: false });
    this.handleHideModalClose();
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.currentOption === prevState.currentOption) {
      if (
        this.state.currentOption === 'RTMP' ||
        this.state.currentOption === 'DacastRTMP' ||
        this.state.currentOption === 'DacastSRT' ||
        this.state.currentOption === 'Telegram' ||
        this.state.currentOption === 'Instagram' ||
        this.state.currentOption === 'SRTCaller' ||
        this.state.currentOption === 'OmnistreamLivePlayerRTMP' ||
        this.state.currentOption === 'OmnistreamLivePlayerSRT'
      ) {
        if (!isEqual(this.state.formFields, prevState.formFields)) {
          this.state.currentDisabled === true &&
            this.setState({ currentDisabled: false });
        }
      }
    }
    if (this.props.exportButtonRole.id === 'create-export') {
      this.checkRequiredFields(this.props.exportButtonRole.currentOption);
      if (this.state.currentOption !== this.props.exportButtonRole.currentOption) {
        this.setState({ currentOption: this.props.exportButtonRole.currentOption });
      }
    }
  }

  componentDidMount() {
    const { handleHideModal, focusedPrimaryId, exportButtonRole } = this.props;
    this.setState({ focusedPrimaryId });
    $(this.modal).modal('show');
    $(this.modal).on('hidden.bs.modal', handleHideModal);
    if (
      exportButtonRole.id === 'create-export' &&
      exportButtonRole.currentOption !== 'SRTListener' &&
      exportButtonRole.currentOption !== 'OmnistreamLivePlayerRTMP' &&
      exportButtonRole.currentOption !== 'OmnistreamLivePlayerSRT'
    ) {
      this.setState({ disabled: true });
    }
  }
  handleHideModalClose(isEdit) {
    const { handleHideModal } = this.props;
    this.setState({
      showVmixIpInput: false,
      localIp: '',
      ipValidationError: '',
      modalError: '',
      serverError: '',
      fieldErrors: {},
      isConfirmDeleteGenerated: false,
      createdExportId: null,
      disabled: false,
      isRegenerated: false,
    });
    $(this.modal).modal('hide');
    handleHideModal(isEdit);
  }

  handleDeleteModal() {
    const { handleHideModal, exportsItemId, handleDelete, deleteLabelItem } =
      this.props;
    $(this.modal).modal('hide');
    handleHideModal();
    handleDelete(exportsItemId);
    deleteLabelItem(exportsItemId);
  }

  handleDeleteLabel = () => {
    const { handleHideModal, exportsItemId, deleteLabelItem } = this.props;
    $(this.modal).modal('hide');
    handleHideModal();
    deleteLabelItem(exportsItemId);
  };

  handleDeleteAllExports = () => {
    const { handleHideModal } = this.props;
    $(this.modal).modal('hide');
    handleHideModal();
    this.deleteAllExports(this.state.focusedPrimaryId);
  };

  deleteAllExports = async (primaryId) => {
    try {
      const response = await axios({
        method: 'delete',
        url:
          EXPORT_APIS.deleteAllExports(primaryId) +
          `?keepAmsExports=${keepAmsExports &&
          (this.props.isUserFreeTrial || this.props.isUserBasic || this.props.isUserLiveOmni)
          }`,
        withCredentials: true,
      });
      if (response.status === 200 || response.status === 201) {
        this.props.fetchItems(false, this.state.focusedPrimaryId);
        const output = this.props.primaryUsers.find(
          (output) => output.id === this.state.focusedPrimaryId
        );
        const nofificationMessage = `All exports was successfully deleted for primary ${this.props.primaryName}`;
        if (output.isActive) {
          this.props.checkIsExistOmniSRT(
            'state',
            nofificationMessage,
            'delete-all'
          );
        } else {
          this.props.showNotification('deleAllExports', nofificationMessage);
        }
      }
    } catch (e) {
      this.props.showNotification('deleAllExports', e.response.data.message);
    }
  };

  handleInputChange = (e) => {
    let value = e.target.value;
    let formFields = { ...this.state.formFields };
    let fieldErrors = { ...(this.state.fieldErrors || {}) };
    formFields[e.target.id] = value;
    delete fieldErrors[e.target.id];
    this.setState({ formFields, fieldErrors, modalError: '', serverError: '' });
  };

  handleChangeExport = (exportRole) => {
    this.setState({ currentDisabled: true });
    this.props.setShowEditModal(true);
    this.handleExport(exportRole);
  };

  defineTypeExport = (field) => {
    const typeExport = {
      id: '',
      name: '',
      buttonType: '',
    };
    switch (field) {
      case 'RTMP':
        return {
          ...typeExport,
          id: 'RTMP',
          name: 'Custom RTMP/S',
          buttonType: 'Apply',
        };
      case 'SRTCaller':
        return {
          ...typeExport,
          id: 'SRTCaller',
          name: 'SRT Caller',
          buttonType: 'Apply',
        };
      case 'SRTListener':
        return {
          ...typeExport,
          id: 'SRTListener',
          name: 'SRT Listener',
          buttonType: 'Generate',
        };
      case 'OmnistreamLivePlayerRTMP':
        return {
          ...typeExport,
          id: 'OmnistreamLivePlayerRTMP',
          name: 'LIVE OMNI - RTMP',
          buttonType: 'Generate',
        };
      case 'OmnistreamLivePlayerSRT':
        return {
          ...typeExport,
          id: 'OmnistreamLivePlayerSRT',
          name: 'LIVE OMNI - SRT',
          buttonType: 'Generate',
        };
      case 'DacastRTMP':
        return {
          ...typeExport,
          id: 'DacastRTMP',
          name: 'Dacast RTMP',
          buttonType: 'Apply',
        };
      case 'DacastSRT':
        return {
          ...typeExport,
          id: 'DacastSRT',
          name: 'Dacast SRT',
          buttonType: 'Apply',
        };
      case 'Telegram':
        return {
          ...typeExport,
          id: 'Telegram',
          name: 'Telegram',
          buttonType: 'Apply',
        };
      case 'Instagram':
        return {
          ...typeExport,
          id: 'Instagram',
          name: 'Instagram',
          buttonType: 'Apply',
        };
      default:
        return null;
    }
  };

  getVmixObsUrl = (url, localIp) => {
    let resultUrl = url || '';
    if (localIp && localIp.trim() !== '') {
      const ip = localIp.trim();
      if (resultUrl.includes('://')) {
        const [protocol, rest] = resultUrl.split('://');
        const firstDelimiter = rest.search(/[:/?]/);
        if (firstDelimiter !== -1) {
          const oldHost = rest.substring(0, firstDelimiter);
          resultUrl = `${protocol}://${rest.replace(oldHost, ip)}`;
        } else {
          resultUrl = `${protocol}://${ip}`;
        }
      } else {
        const firstDelimiter = resultUrl.search(/[:/?]/);
        if (firstDelimiter !== -1) {
          const oldHost = resultUrl.substring(0, firstDelimiter);
          resultUrl = resultUrl.replace(oldHost, ip);
        } else {
          resultUrl = ip;
        }
      }
    }
    return resultUrl.replace(/mode=caller/g, 'mode=listener');
  };

  isValidIpOrHost = (str) => {
    if (!str || !str.trim()) return false;
    const trimmed = str.trim();
    const ipRegex = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;
    const hostRegex = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/;
    return ipRegex.test(trimmed) || hostRegex.test(trimmed);
  };

  handleOpenVideo = (videoUrl) => {
    const modal_content = document.getElementById('modal_content');
    const modal_dialog = document.getElementById('modal_dialog');
    while (modal_content.firstChild) {
      modal_content.removeChild(modal_content.firstChild);
    }
    modal_content.classList.add('modal-content-video');
    modal_dialog.classList.add('modal-dialog-video');
    modal_dialog.classList.add('modal-dialog-centered');

    modal_content.innerHTML += `<div class="livePlayer-text-container"><div class="livePlayer-text">Omnistream Live Player Pro <button class="close-modal-btn-default" data-dismiss="modal"> &times;</button></div></div>`;
    modal_content.innerHTML += `<iframe width="750" height="400" src="${videoUrl}" frameborder="0" allowfullscreen></iframe>`;
  };

  handleOpenNewTab = (videoUrl) => {
    window.open(
      videoUrl,
      '_blank',
      `toolbar=no,scrollbars=no,resizable=yes,width=${window.screen.availWidth},height=${window.screen.availHeight},fullscreen=yes`
    );
    this.handleHideModalClose();
  };

  renderBodyModal = () => {
    const {
      exportButtonRole,
      exportList,
      exportsItemId,
      exportName,
      labelValue,
      handleCopyField,
      primaryName,
      videoUrl,
    } = this.props;

    if (exportButtonRole.id === 'delete') {
      return (
        <Fragment>
          <div className="premium-modal-body text-center">
            <div className="logout-content">
              <i className="material-icons logout-warning-icon">delete_forever</i>
              <p>Are you sure you want to delete <strong>{exportName}</strong> export?</p>
            </div>
            <div className="modal-footer-buttons-container mt-4">
              <button
                type="button"
                className="premium-logout-btn-confirm"
                onClick={this.handleDeleteModal}
              >
                Yes, Delete
              </button>
              <button
                type="button"
                className="premium-logout-btn-cancel"
                onClick={this.handleHideModalClose}
              >
                No, Cancel
              </button>
            </div>
          </div>
        </Fragment>
      );
    }

    if (exportButtonRole.id === 'copy') {
      const isSrtCaller = exportButtonRole.currentOption === 'SRTCaller' || exportName === 'SRT Caller';
      const { showVmixIpInput, localIp, ipValidationError } = this.state;

      const handleCopyUrl = () => {
        handleCopyField(labelValue, `${exportName} URL`);
        this.handleHideModalClose();
      };

      const handleVmixObsClick = () => {
        if (isSrtCaller) {
          this.setState({ showVmixIpInput: true, ipValidationError: '' });
        } else {
          const url = labelValue.replace(/mode=listener/g, 'mode=caller');
          handleCopyField(url, `${exportName} URL`);
          this.handleHideModalClose();
        }
      };

      const handleSrtCallerVmixCopy = () => {
        if (!this.isValidIpOrHost(localIp)) {
          return this.setState({
            ipValidationError: 'Please enter a valid Local IP address or hostname',
          });
        }
        const vmixUrl = this.getVmixObsUrl(labelValue, localIp);
        handleCopyField(vmixUrl, `${exportName} vMix / OBS URL`);
        this.handleHideModalClose();
      };

      return (
        <Fragment>
          <div className="premium-modal-body">
            <div className="logout-content text-center">
              <i className="material-icons logout-warning-icon">content_copy</i>
              <h5 className="modal-title mb-4" style={{ color: '#fff' }}>
                Copy Address
              </h5>
            </div>

            {isSrtCaller && showVmixIpInput ? (
              <div className="form-container" style={{ padding: '0 15px' }}>
                <label className="col-form-label mb-1" style={{ color: '#aaa', fontSize: '13px' }}>
                  Local IP Address or Host <span style={{ color: '#de684f' }}>*</span>
                </label>
                <div className="input-group input-group-sm mb-2">
                  <input
                    type="text"
                    className={`form-control input-custom ${ipValidationError ? 'is-invalid' : ''}`}
                    placeholder="e.g. 192.168.1.100 or host.domain.com"
                    value={localIp || ''}
                    onChange={(e) => this.setState({ localIp: e.target.value, ipValidationError: '' })}
                    autoFocus
                  />
                </div>
                {ipValidationError && (
                  <div style={{ color: '#de684f', fontSize: '12px', marginBottom: '12px' }}>
                    {ipValidationError}
                  </div>
                )}
                <div className="modal-footer-buttons-container mt-4">
                  <button
                    type="button"
                    className="premium-logout-btn-confirm"
                    onClick={handleSrtCallerVmixCopy}
                  >
                    Copy URL
                  </button>
                  <button
                    type="button"
                    className="premium-logout-btn-cancel"
                    onClick={() => this.setState({ showVmixIpInput: false, ipValidationError: '' })}
                  >
                    Back
                  </button>
                </div>
              </div>
            ) : (
              <div className="text-center">
                <div className="modal-footer-buttons-container mt-4">
                  <button
                    id="vmix/obs"
                    type="button"
                    className="premium-logout-btn-confirm"
                    onClick={handleVmixObsClick}
                  >
                    VMIX / OBS
                  </button>
                  <button
                    id="url"
                    type="button"
                    className="premium-logout-btn-confirm"
                    onClick={handleCopyUrl}
                  >
                    URL
                  </button>
                </div>
                <button
                  type="button"
                  className="premium-logout-btn-cancel mt-4"
                  onClick={this.handleHideModalClose}
                >
                  Cancel
                </button>
              </div>
            )}
          </div>
        </Fragment>
      );
    }

    if (exportButtonRole.id === 'delete-all-exports') {
      return (
        <Fragment>
          <div className="premium-modal-body text-center">
            <div className="logout-content">
              <i className="material-icons logout-warning-icon">delete_sweep</i>
              <p>
                Are you sure you want to delete <strong>ALL</strong> exports for primary&nbsp;
                <span className="cap-letter">{primaryName}?</span>
              </p>
            </div>
            <div className="modal-footer-buttons-container mt-4">
              <button
                type="button"
                className="premium-logout-btn-confirm"
                onClick={this.handleDeleteAllExports}
              >
                Yes, Delete All
              </button>
              <button
                type="button"
                className="premium-logout-btn-cancel"
                onClick={this.handleHideModalClose}
              >
                No, Cancel
              </button>
            </div>
          </div>
        </Fragment>
      );
    }

    if (exportButtonRole.id === 'play_video') {
      return (
        <Fragment>
          <div className="premium-modal-body text-center">
            <h5 className="modal-title mb-4" style={{ color: '#fff' }}>
              Choose Playback Method
            </h5>
            <div className="modal-footer-buttons-container mt-4">
              <button
                id="modal"
                type="button"
                className="premium-logout-btn-confirm"
                style={{ minWidth: '160px' }}
                onClick={() => this.handleOpenVideo(videoUrl)}
              >
                Dashboard View
              </button>
              <button
                id="new_window"
                type="button"
                target="_blank"
                className="premium-logout-btn-confirm"
                style={{ minWidth: '160px' }}
                onClick={() => this.handleOpenNewTab(videoUrl)}
              >
                New Tab
              </button>
            </div>
            <button
              type="button"
              className="premium-logout-btn-cancel mt-4"
              onClick={this.handleHideModalClose}
            >
              Cancel
            </button>
          </div>
        </Fragment>
      );
    }

    if (exportButtonRole.id === 'share_video') {
      const shareMessage = `Join and watch my live stream on Omni Live: ${videoUrl}`;
      const WhatsAppMessage = `Join and watch my live stream on Omni Live:%0A${videoUrl}`;
      const WhatsAppLink = `whatsapp://send?text=${WhatsAppMessage}`;
      const fbMessengerLink = `https://www.facebook.com/dialog/send?link=${videoUrl}&app_id=385274096712337&redirect_uri=${window.location.href}`;

      return (
        <Fragment>
          <div className="premium-modal-body">
            <h5 className="modal-title text-center mb-4" style={{ color: '#fff' }}>
              Share Your Live Stream
            </h5>
            <div className="modal_media_container">
              <FacebookShareButton url={videoUrl}>
                <FacebookIcon size={40} round />
              </FacebookShareButton>
              <div className="copy_icon_rounded">
                <FacebookMessengerIcon
                  onClick={() => window.open(fbMessengerLink, '_blank')}
                  size={40}
                  round
                />
              </div>
              <TwitterShareButton url={shareMessage}>
                <TwitterIcon size={40} round />
              </TwitterShareButton>
              <LinkedinShareButton url={videoUrl}>
                <LinkedinIcon size={40} round />
              </LinkedinShareButton>
              <div className="copy_icon_rounded">
                <WhatsappIcon
                  onClick={() => window.open(WhatsAppLink, '_blank')}
                  size={40}
                  round
                />
              </div>
              <TelegramShareButton url={shareMessage}>
                <TelegramIcon size={40} round />
              </TelegramShareButton>
              <EmailShareButton url={shareMessage}>
                <EmailIcon size={40} round />
              </EmailShareButton>
              <div className="copy_icon_rounded">
                <img
                  alt="copy"
                  src={copyIcon}
                  onClick={() => handleCopyField(videoUrl, 'Live Stream URL')}
                ></img>
              </div>
            </div>
            <div className="mt-4">
              <button
                id="modal"
                type="button"
                className="premium-logout-btn-cancel"
                onClick={this.handleHideModalClose}
              >
                Close
              </button>
            </div>
          </div>
        </Fragment>
      );
    }

    if (exportButtonRole.id === 'create-export') {
      const { currentOption } = exportButtonRole;
      const method = EXPORT_METHODS.find(
        (method) => method.id === currentOption
      );
      const typeExportFields = method ? method.fields : [];
      const { currentDisabled } = this.state;
      const exportData = this.defineTypeExport(exportButtonRole.currentOption) || { name: 'Export', buttonType: 'Create' };

      if (this.state.isConfirmDeleteGenerated) {
        return (
          <Fragment>
            <div className="premium-modal-body text-center">
              <div className="logout-content mb-3">
                <i className="material-icons logout-warning-icon" style={{ fontSize: '3rem', color: '#de684f' }}>delete_forever</i>
                <h5 className="modal-title mt-2 mb-2" style={{ color: '#fff', fontWeight: 600 }}>
                  Delete Export?
                </h5>
                <p style={{ color: '#ccc', fontSize: '0.9rem', marginBottom: '4px' }}>
                  {this.state.exportName || exportData.name || 'SRT Listener'} export is already created.
                </p>
                <p style={{ color: '#999', fontSize: '0.85rem' }}>
                  Are you sure you want to delete?
                </p>
              </div>
              <div className="modal-footer-buttons-container mt-4">
                <button
                  type="button"
                  className="premium-logout-btn-confirm"
                  style={{ background: '#de684f', borderColor: '#de684f' }}
                  onClick={this.handleConfirmDeleteGenerated}
                >
                  Yes, Delete
                </button>
                <button
                  type="button"
                  className="premium-logout-btn-cancel"
                  onClick={() => this.setState({ isConfirmDeleteGenerated: false })}
                >
                  No, Cancel
                </button>
              </div>
            </div>
          </Fragment>
        );
      }

      return (
        <Fragment>
          <div className="premium-modal-body">
            <div className="logout-content">
              {this.renderModalExportHeaderIcon(currentOption)}
              <h5 className="modal-title mb-4" style={{ color: '#fff' }}>
                {exportData.name}
              </h5>
            </div>

            <div className="form-container">
              {typeExportFields.map((field) => (
                <Fragment key={field.name}>
                  {(currentOption === 'SRTCaller' ||
                    currentOption === 'OmnistreamLivePlayerSRT') &&
                    (field.id === 'port' || field.id === 'exportStreamId') ? (
                    <>
                      {field.id === 'port' && (
                        <div className="SRTCaller-input-container">
                          {typeExportFields
                            .filter(
                              (elem) =>
                                elem.id === 'port' || elem.id === 'exportStreamId'
                            )
                            .map((field) => (
                              <Fragment key={field.name}>
                                <div className="SRTCaller-input">
                                  <label className="col-form-label">
                                    <div
                                      className={`modal-field-label ${field.required &&
                                        'modal-field-label-required'
                                        }`}
                                    >
                                      {field.name}
                                      {field.required ? (
                                        <span className="modal-field-icon-star">
                                          *
                                        </span>
                                      ) : null}
                                    </div>
                                  </label>
                                  <div className="input-group input-group-sm mb-1">
                                    <input
                                      id={field.id}
                                      className={`form-control input-custom ${field.id === 'key' && 'input-custom-key'
                                        }`}
                                      style={(this.state.fieldErrors && this.state.fieldErrors[field.id]) ? { borderColor: '#de684f', backgroundColor: 'rgba(222, 104, 79, 0.08)' } : {}}
                                      onChange={this.handleInputChange}
                                      value={
                                        this.state.formFields[field.id] || ''
                                      }
                                      disabled={field.disabled || currentDisabled}
                                      placeholder={field.placeholder || ''}
                                    />
                                    <i
                                      className="material-icons premium-copy-icon"
                                      id="copy"
                                      value={field.id.toString()}
                                      onClick={() =>
                                        handleCopyField(
                                          this.state.formFields[field.id],
                                          field.name
                                        )
                                      }
                                    >
                                      content_copy
                                    </i>
                                  </div>
                                  {this.state.fieldErrors && this.state.fieldErrors[field.id] && (
                                    <div style={{ color: '#de684f', fontSize: '12px', marginTop: '2px', marginBottom: '8px', textAlign: 'left' }}>
                                      {this.state.fieldErrors[field.id]}
                                    </div>
                                  )}
                                </div>
                              </Fragment>
                            ))}
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <label className="col-form-label">
                        <div
                          className={`modal-field-label ${field.required && 'modal-field-label-required'
                            }`}
                        >
                          {field.name}
                          {field.required ? (
                            <span className="modal-field-icon-star">*</span>
                          ) : null}
                        </div>
                      </label>
                      <div className="input-group input-group-sm mb-1">
                        <input
                          id={field.id}
                          className={`form-control input-custom ${field.id === 'key' && 'input-custom-key'
                            }`}
                          style={(this.state.fieldErrors && this.state.fieldErrors[field.id]) ? { borderColor: '#de684f', backgroundColor: 'rgba(222, 104, 79, 0.08)' } : {}}
                          onChange={this.handleInputChange}
                          value={this.state.formFields[field.id] || ''}
                          disabled={field.disabled || currentDisabled}
                          placeholder={field.placeholder || ''}
                        />
                        <button
                          className="material-icons premium-copy-btn"
                          id="copy"
                          value={field.id.toString()}
                          onClick={() =>
                            handleCopyField(
                              this.state.formFields[field.id],
                              field.name
                            )
                          }
                        >
                          content_copy
                        </button>
                      </div>
                      {this.state.fieldErrors && this.state.fieldErrors[field.id] && (
                        <div style={{ color: '#de684f', fontSize: '12px', marginTop: '2px', marginBottom: '8px', textAlign: 'left' }}>
                          {this.state.fieldErrors[field.id]}
                        </div>
                      )}
                    </>
                  )}
                </Fragment>
              ))}
            </div>

            {this.state.serverError && (
              <div
                className="text-center mt-3"
                style={{
                  background: 'rgba(222, 104, 79, 0.15)',
                  border: '1px solid #de684f',
                  color: '#ff8a73',
                  fontSize: '13px',
                  borderRadius: '6px',
                  padding: '8px 12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                }}
              >
                <i className="material-icons" style={{ fontSize: '18px', color: '#de684f' }}>
                  error_outline
                </i>
                <span>{this.state.serverError}</span>
              </div>
            )}

            <div className="modal-footer-buttons-container mt-4">
              <button
                type="button"
                className="premium-logout-btn-confirm"
                onClick={
                  (currentOption === 'SRTListener' ||
                    currentOption === 'OmnistreamLivePlayerRTMP' ||
                    currentOption === 'OmnistreamLivePlayerSRT') &&
                    this.state.disabled
                    ? () => this.handleHideModalClose(true)
                    : () => this.handleExport('create-export')
                }
              >
                {(currentOption === 'SRTListener' ||
                  currentOption === 'OmnistreamLivePlayerRTMP' ||
                  currentOption === 'OmnistreamLivePlayerSRT') &&
                  this.state.disabled
                  ? 'Save & Close'
                  : exportData.buttonType}
              </button>
              <button
                type="button"
                className="premium-logout-btn-cancel"
                onClick={
                  (currentOption === 'SRTListener' ||
                    currentOption === 'OmnistreamLivePlayerRTMP' ||
                    currentOption === 'OmnistreamLivePlayerSRT') &&
                    this.state.disabled
                    ? () => this.setState({ isConfirmDeleteGenerated: true })
                    : this.handleHideModalClose
                }
              >
                Cancel
              </button>
            </div>
          </div>
        </Fragment>
      );
    }

    if (exportButtonRole.id === 'delete-label') {
      return (
        <Fragment>
          <div className="premium-modal-body text-center">
            <div className="logout-content">
              <i className="material-icons logout-warning-icon">label_off</i>
              <p>
                Are you sure you want to delete <span className="cap-letter">"{labelValue}"</span> label for {exportName} export?
              </p>
            </div>
            <div className="modal-footer-buttons-container mt-4">
              <button
                type="button"
                className="premium-logout-btn-confirm"
                onClick={this.handleDeleteLabel}
              >
                Yes, Delete
              </button>
              <button
                type="button"
                className="premium-logout-btn-cancel"
                onClick={this.handleHideModalClose}
              >
                No, Cancel
              </button>
            </div>
          </div>
        </Fragment>
      );
    }
    if (exportButtonRole.id === 'edit') {
      const exportItem = exportList.find((item) => item.id === exportsItemId);
      if (exportItem) {
        if (exportItem.type === 7) {
          if (this.state.currentOption !== 'OmnistreamLivePlayerRTMP') {
            exportItem['url'] = `${exportItem.protocol || 'rtmp'}://${exportItem.host}${exportItem.port ? `:${exportItem.port}` : ''}${exportItem.endpoint ? `/${exportItem.endpoint}` : ''}`;
            this.setState({
              currentOption: 'OmnistreamLivePlayerRTMP',
              formFields: exportItem,
              exportName: 'Omnistream Live Player',
              currentDisabled: false,
            });
          }
        } else if (exportItem.type === 8) {
          if (this.state.currentOption !== 'OmnistreamLivePlayerSRT') {
            this.setState({
              currentOption: 'OmnistreamLivePlayerSRT',
              formFields: exportItem,
              exportName: 'LIVE OMNI - SRT',
              currentDisabled: false,
            });
          }
        } else if (exportItem.type === 13) {
          if (this.state.currentOption !== 'DacastRTMP') {
            exportItem['url'] = `${exportItem.protocol || 'rtmp'}://${exportItem.host}${exportItem.port ? `:${exportItem.port}` : ''}${exportItem.endpoint ? `/${exportItem.endpoint}` : ''}`;
            this.setState({
              currentOption: 'DacastRTMP',
              formFields: exportItem,
              exportName: 'Dacast RTMP',
              currentDisabled: true,
            });
          }
        } else if (exportItem.type === 10) {
          if (this.state.currentOption !== 'Telegram') {
            exportItem['url'] = `${exportItem.protocol || 'rtmps'}://${exportItem.host}${exportItem.port ? `:${exportItem.port}` : ''}${exportItem.endpoint ? `/${exportItem.endpoint}` : ''}`;
            this.setState({
              currentOption: 'Telegram',
              formFields: exportItem,
              exportName: 'Telegram',
              currentDisabled: true,
            });
          }
        } else if (exportItem.type === 11) {
          if (this.state.currentOption !== 'Instagram') {
            exportItem['url'] = `${exportItem.protocol || 'rtmps'}://${exportItem.host}${exportItem.port ? `:${exportItem.port}` : ''}${exportItem.endpoint ? `/${exportItem.endpoint}` : ''}`;
            this.setState({
              currentOption: 'Instagram',
              formFields: exportItem,
              exportName: 'Instagram',
              currentDisabled: true,
            });
          }
        } else if (exportItem.type === 14) {
          if (this.state.currentOption !== 'DacastSRT') {
            let builtUrl = exportItem.url;
            if (!builtUrl && exportItem.host) {
              builtUrl = `srt://${exportItem.host}:${exportItem.port}`;
              let hasQueryParam = false;
              if (exportItem.key) {
                builtUrl += `?pbkeylen=32&passphrase=${exportItem.key}`;
                hasQueryParam = true;
              }
              if (exportItem.exportStreamId) {
                builtUrl += hasQueryParam ? '&' : '?';
                builtUrl += `streamid=${exportItem.exportStreamId}`;
                hasQueryParam = true;
              }
              builtUrl += hasQueryParam ? '&' : '?';
              builtUrl += 'mode=caller';
            }
            exportItem['url'] = builtUrl;
            this.setState({
              currentOption: 'DacastSRT',
              formFields: exportItem,
              exportName: 'Dacast SRT',
              currentDisabled: true,
            });
          }
        } else if (exportItem.type === 1) {
          if (this.state.currentOption !== 'SRTCaller') {
            this.setState({
              currentOption: 'SRTCaller',
              formFields: exportItem,
              exportName: 'SRT Caller',
              currentDisabled: true,
            });
          }
        } else if (exportItem.type === 2) {
          if (this.state.currentOption !== 'SRTListener') {
            this.setState({
              currentOption: 'SRTListener',
              formFields: exportItem,
              exportName: 'SRT Listener',
              currentDisabled: false,
            });
          }
        } else if (exportItem.type === 0 || exportItem.protocol === 'rtmp' || exportItem.protocol === 'rtmps') {
          if (this.state.currentOption !== 'RTMP') {
            exportItem['url'] = `${exportItem.protocol || 'rtmp'}://${exportItem.host}${exportItem.port ? `:${exportItem.port}` : ''}${exportItem.endpoint ? `/${exportItem.endpoint}` : ''}`;
            this.setState({
              currentOption: 'RTMP',
              formFields: exportItem,
              exportName: 'Custom RTMP/S',
              currentDisabled: true,
            });
          }
        }
      }
      const typeExportFields =
        this.state.currentOption &&
        EXPORT_METHODS.find((method) => method.id === this.state.currentOption)
          .fields;
      const form = this.state.currentOption && (
        <Fragment>
          <div className="premium-modal-body">
            <div className="logout-content">
              {this.renderModalExportHeaderIcon(this.state.currentOption)}
              <h5 className="modal-title mb-4" style={{ color: '#fff' }}>
                {this.state.exportName}
              </h5>
            </div>

            <div className="form-container">
              {typeExportFields.map((field) => (
                <Fragment key={field.name}>
                  {this.state.currentOption === 'SRTCaller' &&
                    (field.id === 'port' || field.id === 'exportStreamId') ? (
                    <>
                      {field.id === 'port' && (
                        <div className="SRTCaller-input-container">
                          {typeExportFields
                            .filter(
                              (elem) =>
                                elem.id === 'port' || elem.id === 'exportStreamId'
                            )
                            .map((field) => (
                              <Fragment key={field.name}>
                                <div className="SRTCaller-input">
                                  <label className="col-form-label">
                                    {field.name}
                                  </label>
                                  <div className="input-group input-group-sm mb-2">
                                    <input
                                      id={field.id}
                                      className={`form-control input-custom ${field.id === 'key' && 'input-custom-key'
                                        }`}
                                      onChange={this.handleInputChange}
                                      value={this.state.formFields[field.id] || ''}
                                      disabled={
                                        this.state.currentOption ===
                                          'SRTListener' ||
                                          this.state.currentOption ===
                                          'OmnistreamLivePlayerRTMP'
                                          ? field.disabled ||
                                          this.state.currentDisabled
                                          : false
                                      }
                                      placeholder={field.placeholder || ''}
                                    />
                                    <i
                                      className="material-icons premium-copy-icon"
                                      id="copy"
                                      value={field.id.toString()}
                                      onClick={() =>
                                        handleCopyField(
                                          this.state.formFields[field.id],
                                          field.name
                                        )
                                      }
                                    >
                                      content_copy
                                    </i>
                                  </div>
                                </div>
                              </Fragment>
                            ))}
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <label className="col-form-label">{field.name}</label>
                      <div className="input-group input-group-sm mb-1">
                        <input
                          id={field.id}
                          className={`form-control input-custom ${field.id === 'key' && 'input-custom-key'
                            }`}
                          style={(this.state.fieldErrors && this.state.fieldErrors[field.id]) ? { borderColor: '#de684f', backgroundColor: 'rgba(222, 104, 79, 0.08)' } : {}}
                          onChange={this.handleInputChange}
                          value={this.state.formFields[field.id] || ''}
                          disabled={
                            this.state.currentOption === 'SRTListener' ||
                              this.state.currentOption === 'OmnistreamLivePlayerRTMP'
                              ? field.disabled || this.state.currentDisabled
                              : false
                          }
                          placeholder={field.placeholder || ''}
                        />
                        <button
                          className="material-icons premium-copy-btn"
                          id="copy"
                          value={field.id.toString()}
                          onClick={() =>
                            handleCopyField(
                              this.state.formFields[field.id],
                              field.name
                            )
                          }
                        >
                          content_copy
                        </button>
                      </div>
                      {this.state.fieldErrors && this.state.fieldErrors[field.id] && (
                        <div style={{ color: '#de684f', fontSize: '12px', marginTop: '2px', marginBottom: '8px', textAlign: 'left' }}>
                          {this.state.fieldErrors[field.id]}
                        </div>
                      )}
                    </>
                  )}
                </Fragment>
              ))}
            </div>

            {this.state.serverError && (
              <div
                className="text-center mt-3"
                style={{
                  background: 'rgba(222, 104, 79, 0.15)',
                  border: '1px solid #de684f',
                  color: '#ff8a73',
                  fontSize: '13px',
                  borderRadius: '6px',
                  padding: '8px 12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                }}
              >
                <i className="material-icons" style={{ fontSize: '18px', color: '#de684f' }}>
                  error_outline
                </i>
                <span>{this.state.serverError}</span>
              </div>
            )}

            {this.state.isRegenerated && (
              <div
                className="text-center mt-3"
                style={{
                  background: 'rgba(16, 185, 129, 0.12)',
                  border: '1px solid rgba(16, 185, 129, 0.3)',
                  color: '#86EFAC',
                  fontSize: '13px',
                  borderRadius: '6px',
                  padding: '8px 12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px',
                }}
              >
                <i className="material-icons" style={{ fontSize: '18px', color: '#10B981' }}>
                  check_circle
                </i>
                <span>New credentials generated successfully</span>
              </div>
            )}

            <div className="modal-footer-buttons-container mt-4">
              {this.state.currentOption === 'SRTListener' ||
                this.state.currentOption === 'OmnistreamLivePlayerRTMP' ? (
                <button
                  disabled={this.state.currentDisabled || this.state.isRegenerated}
                  type="button"
                  className={`premium-logout-btn-confirm ${this.state.isRegenerated ? 'is-regenerated' : ''}`}
                  onClick={this.handleChangeExport}
                >
                  {this.state.isRegenerated ? 'Regenerated ✓' : 'Regenerate'}
                </button>
              ) : (
                <button
                  disabled={this.state.currentDisabled}
                  type="button"
                  title="Please change export settings in order to save"
                  alt="Please change export settings in order to save"
                  className="premium-logout-btn-confirm"
                  onClick={() => this.handleChangeExport('edit')}
                >
                  {'Save & Close'}
                </button>
              )}
              <button
                type="button"
                className="premium-logout-btn-cancel"
                onClick={this.handleHideModalClose}
              >
                {this.state.currentOption === 'SRTListener' ||
                  this.state.currentOption === 'OmnistreamLivePlayerRTMP'
                  ? 'Close'
                  : 'Cancel'}
              </button>
            </div>
          </div>
        </Fragment>
      );
      return form;
    }
  };

  generateAMSExport = async (config) => {
    try {
      const data = {
        exportStreamId: '',
        isEnabled: true,
        protocol: config.protocol,
        src: 0,
        type: config.type,
      };

      const response = await axios({
        method: 'post',
        url: config.url,
        withCredentials: true,
        data,
      });

      if (response.status === 200) {
        const isExistUserId = isExistUser(this.state.focusedPrimaryId);
        if (!isExistUserId) {
          // If we create export type 7 or 8 then we should update codec type to H.264
          this.props.handleUpdateCodecType('H.264');
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  getAMSExportInfo = async (focusedPrimaryId, protocol) => {
    try {
      const response = await axios({
        method: 'get',
        url: EXPORT_APIS.getAMSExport(focusedPrimaryId),
        withCredentials: true,
      });

      const amsExportProtocol = response.data.amsExportProtocol;
      if (!amsExportProtocol) {
        await this.generateAMSExport(
          this.checkTypeAMSExportAPI(protocol, focusedPrimaryId)
        );
      } else if (amsExportProtocol.toLowerCase() !== protocol) {
        await this.generateAMSExport(
          this.checkTypeAMSExportAPI(protocol, focusedPrimaryId)
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  checkTypeAMSExportAPI = (protocol, focusedPrimaryId) => {
    switch (protocol) {
      case 'rtmp':
      case 'rtmps':
        return {
          url: EXPORT_APIS.generateExportRTMP(focusedPrimaryId),
          type: 7,
          protocol,
        };
      case 'srt':
        return {
          url: EXPORT_APIS.generateExportSRT(focusedPrimaryId),
          type: 8,
          protocol,
        };
      default:
        return '';
    }
  };

  handleExport = async (exportRole) => {
    const { exportsItemId, handleDelete } = this.props;

    const currentOption = EXPORT_METHODS.find(
      (method) => method.id === this.state.currentOption
    );
    const [firstField, secondField, thirdField, fourthField] =
      currentOption.fields;
    let reqData = {};
    reqData['protocol'] = 'srt';

    let fieldErrors = {};
    if (
      (firstField && !this.parseField(firstField, reqData, fieldErrors)) ||
      (secondField && !this.parseField(secondField, reqData, fieldErrors)) ||
      (thirdField && !this.parseField(thirdField, reqData, fieldErrors)) ||
      (fourthField && !this.parseField(fourthField, reqData, fieldErrors)) ||
      Object.keys(fieldErrors).length > 0
    ) {
      return this.setState({ fieldErrors, currentDisabled: false });
    }

    reqData['type'] = EXPORT_METHODS.find(
      (item) => item.id === this.state.currentOption
    ).type;
    reqData['src'] = 0; //src; - sends video only
    reqData['isEnabled'] = true;
    reqData['exportCreationSource'] = this.props.isController
      ? EXPORT_CREATION_SOURCE.CONTROLLER
      : EXPORT_CREATION_SOURCE.DASHBOARD;
    try {
      if (exportRole === 'edit') {
        const response = await axios({
          method: 'put',
          url: EXPORT_APIS.putExport(
            this.state.focusedPrimaryId,
            exportsItemId
          ),
          withCredentials: true,
          data: reqData,
        });
        if (response.status === 200 || response.status === 201) {
          this.props.fetchItems(false, this.state.focusedPrimaryId);

          this.props.showNotification(
            'export',
            `${currentOption.name} export has been changed successfully`
          );

          this.handleHideModalClose(true);
        }
      } else {
        await handleDelete(exportsItemId, true);

        // if export !== type 8 or 7 then we check if we have AMS export

        if (showAmsExportsAndUseLogic) {
          if (
            this.state.currentOption !== 'OmnistreamLivePlayerRTMP' &&
            this.state.currentOption !== 'OmnistreamLivePlayerSRT' &&
            useAmsExportConvertAndLogic &&
            (this.props.isUserFreeTrial || this.props.isUserBasic || this.props.isUserLiveOmni)
          ) {
            await this.getAMSExportInfo(
              this.state.focusedPrimaryId,
              reqData.protocol
            );
          }
        }

        const response = await axios({
          method: 'post',
          url:
            this.state.currentOption === 'OmnistreamLivePlayerRTMP'
              ? EXPORT_APIS.generateExportRTMP(this.state.focusedPrimaryId)
              : this.state.currentOption === 'OmnistreamLivePlayerSRT'
                ? EXPORT_APIS.generateExportSRT(this.state.focusedPrimaryId)
                : EXPORT_APIS.setExport(this.state.focusedPrimaryId),
          withCredentials: true,
          data: reqData,
        });
        let fields = this.state.formFields;
        if (response.status === 200 || response.status === 201) {
          let data = response.data['entry'];
          if (currentOption.id === 'SRTListener') {
            //SRT
            this.state.formFields['host'] = data.host;
            this.state.formFields['port'] = data.port;
            this.state.formFields['key'] = data.key;
          } else if (currentOption.id === 'SRTCaller') {
            this.state.formFields['host'] = data.host;
            this.state.formFields['port'] = data.port;
            this.state.formFields['key'] = data.key;
            this.state.formFields['exportStreamId'] = data.exportStreamId;
          } else if (currentOption.id === 'OmnistreamLivePlayerSRT') {
            this.state.formFields['host'] = data.host;
            this.state.formFields['port'] = data.port;
            this.state.formFields['exportStreamId'] = data.exportStreamId;
          } else if (currentOption.id === 'DacastSRT') {
            let builtUrl = `srt://${data.host}:${data.port}`;
            let hasQueryParam = false;
            if (data.key) {
              builtUrl += `?pbkeylen=32&passphrase=${data.key}`;
              hasQueryParam = true;
            }
            if (data.exportStreamId) {
              builtUrl += hasQueryParam ? '&' : '?';
              builtUrl += `streamid=${data.exportStreamId}`;
              hasQueryParam = true;
            }
            builtUrl += hasQueryParam ? '&' : '?';
            builtUrl += 'mode=caller';
            this.state.formFields['url'] = builtUrl;
          } else {
            this.state.formFields['url'] =
              data.protocol +
              '://' +
              data.host +
              (data.port ? ':' + data.port : '') +
              '/' +
              data.endpoint;
            this.state.formFields['key'] = data.key;
          }
        }

        this.setState({ formFields: fields });

        const isExistUserId = isExistUser(this.state.focusedPrimaryId);
        if (!isExistUserId && showAmsExportsAndUseLogic) {
          if (
            this.state.currentOption !== 'OmnistreamLivePlayerRTMP' &&
            this.state.currentOption !== 'OmnistreamLivePlayerSRT'
          ) {
            this.props.handleUpdateCodecType('H.264');
          }

          if (this.state.currentOption === 'OmnistreamLivePlayerRTMP') {
            this.props.handleUpdateCodecType('H.264');
          }

          if (this.state.currentOption === 'OmnistreamLivePlayerSRT') {
            this.props.handleUpdateCodecType('H.265');
          }
        }

        if (
          this.state.currentOption !== 'SRTListener' &&
          this.state.currentOption !== 'OmnistreamLivePlayerRTMP' &&
          this.state.currentOption !== 'OmnistreamLivePlayerSRT'
        ) {
          if (this.props.fetchItems) {
            this.props.fetchItems(true, this.state.focusedPrimaryId);
          }
          if (this.props.showNotification) {
            this.props.showNotification(
              'export',
              `${currentOption.name} export has been created successfully`
            );
          }
          this.handleHideModalClose(true);
        } else {
          this.props.fetchItems(true, this.state.focusedPrimaryId);
          const isRegen = exportRole !== 'create-export';
          const actionWord = isRegen ? 'regenerated' : 'created';
          this.props.showNotification(
            'export',
            `${currentOption.name} export has been ${actionWord} successfully`
          );
          const createdEntry = response && response.data && response.data['entry'];
          const createdId = createdEntry ? createdEntry.id : null;
          this.setState({
            disabled: true,
            currentDisabled: true,
            isRegenerated: isRegen,
            createdExportId: createdId,
          });
        }
      }
    } catch (error) {
      const serverMessage =
        (error && error.response && error.response.data && error.response.data.message) ||
        (error && error.message) ||
        'Failed to save export configuration';
      console.log(serverMessage);
      this.setState({ currentDisabled: false, serverError: serverMessage });
      this.props.showNotification('export', serverMessage);
    }
  };

  parseField = (field, reqData, fieldErrors = {}) => {
    let inputVal = this.state.formFields[field.id];
    if (field.required && (!inputVal || !inputVal.toString().trim())) {
      const errMsg = `${field.name} is required`;
      fieldErrors[field.id] = errMsg;
      this.setState({ modalError: errMsg });
      this.props.showNotification('export', errMsg);
      return false;
    }

    if (field.id === 'url') {
      let inputUrl = inputVal;
      if (inputUrl) {
        try {
          if (this.state.currentOption === 'DacastSRT') {
            let url = inputUrl.trim();
            let protocol = 'srt';
            if (url.includes('://')) {
              const parts = url.split('://');
              protocol = parts[0];
              url = parts[1];
            }
            reqData['protocol'] = protocol;

            let queryString = '';
            if (url.includes('?')) {
              const parts = url.split('?');
              url = parts[0];
              queryString = parts[1];
            }

            let passphrase = '';
            let streamId = '';
            if (queryString) {
              const searchParams = new URLSearchParams(queryString);
              if (searchParams.has('passphrase')) passphrase = searchParams.get('passphrase');
              if (searchParams.has('key')) passphrase = searchParams.get('key');
              if (searchParams.has('streamid')) streamId = searchParams.get('streamid');
              if (searchParams.has('exportStreamId')) streamId = searchParams.get('exportStreamId');
            }

            let dst = url;
            let endpoint = '';
            if (url.includes('/')) {
              const parts = url.split('/');
              dst = parts[0];
              endpoint = parts.slice(1).join('/');
            }

            let host = dst;
            let port = null;
            if (dst.includes(':')) {
              const parts = dst.split(':');
              host = parts[0];
              port = parseInt(parts[1], 10);
            }

            reqData['host'] = host;
            reqData['port'] = isNaN(port) ? null : port;
            reqData['exportStreamId'] = (streamId || endpoint) ? (streamId || endpoint) : null;
            reqData['key'] = passphrase ? passphrase : null;
          } else {
            inputUrl = inputUrl.replace(/\s/g, '');
            const isSRT = this.state.currentOption.toLowerCase().includes('srt');
            const expectedFormat = isSRT ? 'srt://...' : 'rtmp://... or rtmps://...';
            const urlTypeError = `Invalid ${isSRT ? 'SRT' : 'RTMP'} URL format (e.g. ${expectedFormat})`;

            if (!inputUrl.includes('://')) {
              fieldErrors[field.id] = urlTypeError;
              this.setState({ modalError: urlTypeError });
              this.props.showNotification('invalid_url', urlTypeError);
              return false;
            }
            const [protocol, str1] = inputUrl.split('://');
            if (!str1) {
              fieldErrors[field.id] = urlTypeError;
              this.setState({ modalError: urlTypeError });
              this.props.showNotification('invalid_url', urlTypeError);
              return false;
            }
            const [str2, passphrase] = str1.split('?passphrase=');
            const [dst, endpoint] = str2.split('/');
            let [host, port] = dst.split(':');
            port = parseInt(port);
            reqData['protocol'] = protocol;
            reqData['endpoint'] = endpoint;
            reqData['key'] = passphrase ? passphrase : null;
            reqData['host'] = host;
            reqData['port'] = port;
          }
        } catch (error) {
          const isSRT = this.state.currentOption.toLowerCase().includes('srt');
          const expectedFormat = isSRT ? 'srt://...' : 'rtmp://... or rtmps://...';
          const urlTypeError = `Invalid ${isSRT ? 'SRT' : 'RTMP'} URL format (e.g. ${expectedFormat})`;
          fieldErrors[field.id] = urlTypeError;
          this.setState({ modalError: urlTypeError });
          this.props.showNotification('invalid_url', urlTypeError);
          return false;
        }
      }
    } else if (field.id === 'host') {
      let inputHost = this.state.formFields[field.id];
      if (inputHost) {
        reqData['host'] = inputHost;
      }
    } else if (field.id === 'port') {
      let inputPort = this.state.formFields[field.id];
      if (inputPort) {
        if (!isNaN(inputPort)) {
          reqData['port'] = parseInt(inputPort);
        } else {
          this.props.showNotification('invalid_url', 'Invalid port');
          return false;
        }
      }
    } else if (field.id === 'key') {
      let inputKey = this.state.formFields[field.id];
      if (inputKey) {
        reqData['key'] = inputKey;
      } else {
        reqData['key'] = null;
      }
    } else if (field.id === 'exportStreamId') {
      let inputStreamId = this.state.formFields[field.id];
      if (inputStreamId) {
        reqData['exportStreamId'] = inputStreamId;
      } else {
        reqData['exportStreamId'] = null;
      }
    }
    return true;
  };

  isEmptyObject = (obj) => {
    for (let i in obj) {
      if (obj.hasOwnProperty(i)) {
        return false;
      }
    }
    return true;
  };

  checkRequiredFields = (currentOption) => {
    if (
      currentOption === 'SRTListener' ||
      currentOption === 'OmnistreamLivePlayerRTMP' ||
      currentOption === 'OmnistreamLivePlayerSRT'
    ) {
      return;
    } else {
      const { formFields } = this.state;
      if (this.isEmptyObject(formFields)) {
        return;
      }
      const method = EXPORT_METHODS.find(
        (method) => method.id === currentOption
      );
      const exportFields = method ? method.fields.filter((field) => field.required === true) : [];

      if (exportFields.length === 1) {
        if (formFields[exportFields[0].id]) {
          if (this.state.disabled !== false) {
            this.setState({ disabled: false });
          }
        } else {
          if (this.state.disabled !== true) {
            this.setState({ disabled: true });
          }
        }
      } else if (exportFields.length > 1) {
        let isFill = [];
        exportFields.forEach((elem) => {
          if (formFields[elem.id]) {
            isFill.push(true);
          } else {
            isFill.push(false);
          }
        });
        const reducer = (previousValue, currentValue) =>
          previousValue && currentValue;
        const isFillAllFields = isFill.reduce(reducer, true);
        if (isFillAllFields) {
          if (this.state.disabled !== false) this.setState({ disabled: false });
        } else {
          if (this.state.disabled !== true) this.setState({ disabled: true });
        }
      } else {
        if (this.state.disabled !== false) this.setState({ disabled: false });
      }
    }
  };

  renderModalExportHeaderIcon(currentOption) {
    if (!currentOption) return null;

    let imgSrc = null;
    let altText = '';

    if (currentOption === 'SRTCaller' || currentOption === 'SRTListener') {
      imgSrc = srtLogo;
      altText = 'SRT Logo';
    } else if (currentOption && currentOption.includes('Dacast')) {
      imgSrc = dacastIcon;
      altText = 'Dacast Logo';
    } else if (currentOption === 'Telegram') {
      imgSrc = telegramIcon;
      altText = 'Telegram Logo';
    } else if (currentOption === 'Instagram') {
      imgSrc = instagramIcon;
      altText = 'Instagram Logo';
    } else if (currentOption === 'Facebook') {
      imgSrc = facebookIcon;
      altText = 'Facebook Logo';
    } else if (currentOption === 'Youtube') {
      imgSrc = youtubeIcon;
      altText = 'YouTube Logo';
    } else if (currentOption === 'Twitch') {
      imgSrc = twitchIcon;
      altText = 'Twitch Logo';
    } else if (currentOption === 'Kick') {
      imgSrc = kickIcon;
      altText = 'Kick Logo';
    }

    if (imgSrc) {
      return (
        <img
          src={imgSrc}
          alt={altText}
          className="modal-export-header-logo mb-3"
          style={{ width: '44px', height: '44px', objectFit: 'contain', display: 'block', margin: '0 auto 12px auto' }}
        />
      );
    }

    const iconName = this.getExportIcon(currentOption);
    if (!iconName) return null;

    let iconClass = 'logout-warning-icon';
    if (currentOption === 'RTMP') iconClass += ' rtmp-icon';
    else if (currentOption && currentOption.includes('SRT')) iconClass += ' srt-icon';
    else if (currentOption === 'OmnistreamLivePlayerRTMP' || currentOption === 'OmnistreamLivePlayerSRT') iconClass += ' omni-icon';

    return (
      <i className={`material-icons ${iconClass}`}>
        {iconName}
      </i>
    );
  }

  getExportIcon(methodId) {
    switch (methodId) {
      case 'RTMP':
      case 'DacastRTMP':
      case 'Telegram':
      case 'Instagram':
      case 'OmnistreamLivePlayerRTMP':
        return 'cloud_upload';
      case 'SRTCaller':
      case 'SRTListener':
      case 'DacastSRT':
      case 'OmnistreamLivePlayerSRT':
        return 'settings_input_antenna';
      default:
        return null;
    }
  }

  render() {
    return (
      <div
        className="modal fade"
        ref={(modal) => (this.modal = modal)}
        id="modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modalLabel"
        aria-hidden="true"
      >
        <div id="modal_dialog" className="modal-dialog modal-dialog-centered" role="document">
          <div id="modal_content" className="modal-content">
            {this.renderBodyModal()}
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;
